import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useNotificationRefresh = () => {
    const queryClient = useQueryClient();

    const refreshNotifications = useCallback(() => {
        console.log('[useNotificationRefresh] Refreshing notifications...');
        // Force refetch badge count immediately
        queryClient.refetchQueries({ queryKey: ['notifications-count'] });
        // Invalidate list
        queryClient.invalidateQueries({ queryKey: ['notifications'] });

        // Double-check after 500ms to handle potential DB replication lag/race conditions
        setTimeout(() => {
            console.log('[useNotificationRefresh] Delayed refresh check...');
            queryClient.refetchQueries({ queryKey: ['notifications-count'] });
        }, 500);
    }, [queryClient]);

    return refreshNotifications;
};
